import { ObservableArray, View } from "binder"
import { ProductionRestartEditorViewModel } from "./productionRestartEditor-viewModel"
import moment from "moment";
import { TimePart, TimeSelectorViewModel } from "src/uicomponents/components/timeSelector/timeSelector-viewModel";

export class ProductionRestartEditorView extends View<ProductionRestartEditorViewModel> {
    GetViewUniqueId(): string {
        return "V-441D2C88-9CAF-4987-87EA-D2EECBFDA1F2"
    }
    loadHtml(): string {
        let element = require('./productionRestartEditor.html').default;
        let style = require('./productionRestartEditor.less');
        return element;
    }
    constructor() {
        super();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set date(v: moment.Moment) { this._date = v; } public get date(): moment.Moment { return this._date; } private _date: moment.Moment;
    public set from(v: moment.Moment) { this._from = v; } public get from(): moment.Moment { return this._from; } private _from: moment.Moment;
    public set until(v: moment.Moment) { this._until = v; } public get until(): moment.Moment { return this._until; } private _until: moment.Moment;
    public set productLineName(v: string) { this._productLineName = v; } public get productLineName(): string { return this._productLineName; } private _productLineName: string;
    public set workStationName(v: string) { this._workStationName = v; } public get workStationName(): string { return this._workStationName; } private _workStationName: string;
    public set stopReasonName(v: string) { this._stopReasonName = v; } public get stopReasonName(): string { return this._stopReasonName; } private _stopReasonName: string;
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName; } private _personnelName: string;
    public set type(v: number) { this._type = v; } public get type(): number { return this._type; } private _type: number;
    public set description(v: string) { this._description = v; } public get description(): string { return this._description; } private _description: string;
    public set isOpen(v: boolean) { this._isOpen = v; } public get isOpen(): boolean { return this._isOpen; } private _isOpen: boolean;
    public set timeSelector(v: TimeSelectorViewModel) { this._timeSelector = v; } public get timeSelector(): TimeSelectorViewModel { return this._timeSelector; } private _timeSelector: TimeSelectorViewModel;

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    back() {
        this.dataContext.back();
    }

    save() {
        this.dataContext.save();
    }
}
